const apiDomain = 'https://www.77payments.com'
const checkoutUrl = '/a/n/checkout/'
const LoadingAnimation = function () {
    let t = null;
    return {
        show: function () {
            var e;
            (t = t || ((e = document.createElement("style")).innerHTML = `
            .loader-container {
                position: fixed;
                top: 0;
                left: 0;
                width: 100vw;
                height: 100%;
                display: flex;
                justify-content: center;
                align-items: center;
                background-color: rgba(255, 255, 255, 0);
                z-index: 9999;
                animation: fadeInBackground 3s forwards;
            }

            .custom-loader {
                width: 100px;
                height: 100px;
                border: 5px solid rgba(0, 0, 0, 0.1);
                border-radius: 50%;
                border-top-color: #0070ba;
                animation: spin 1s ease-in-out infinite;
                position: relative;
            }

            .spinnerImage {
                width: 50px;
                height: 50px;
                background: url("data:image/png;base64,UklGRnABAABXRUJQVlA4WAoAAAAQAAAAMQAAMQAAQUxQSPkAAAABgHNtmzFnFlVs2+nY2pVT2uyM1rbRmbublPwDtm3byRvPzBeWETEB6Ls0yhm6hqeVRk8uUzS6ACYbC2v6b2HRmRmOpw9FuuitWOgm5HEYYH+3boY+FudBOT2loy019FlOM/hRqwcL9Hmh2SMJSmpPTQjXFWIpRYMtFnt7kFLHGRcL1T0J0RkaR/iJYEhnaYBAABjRWSHh929n17O8snJ/vYJ/AFsrK8PJHAKmDwfdPN7kEA+/Z72bx5uAdAIpYIhosgbnCRSABBXEW/lnKjRnnDgUME7iD8dqdGIc/j9cDPhxaagvjRGQXQa6T14EkHhUXgHFZBP0lQEAVlA4IFAAAABwBQCdASoyADIAPrFCmEwnI6KiO+gA4BYJaQAAzFIU/21BJ4dSsxASuQcoDVJ87AtR8OBYAP7pnf/8Ce9/2aAf//gAXu38nRI/0tAAAAAAAA==") no-repeat center;
                background-size: contain;
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
            }

            @keyframes spin {
                to { transform: rotate(360deg); }
            }

            @keyframes fadeInBackground {
                0% {
                    background-color: rgba(255, 255, 255, 0); 
                }
                100% {
                    background-color: rgba(255, 255, 255, 1);
                }
            }
        `, document.head.appendChild(e), (e = document.createElement("div")).className = "loader-container", e.innerHTML = `
            <div class="custom-loader">&#8203;</div>
            <div class="spinnerImage">&#8203;</div>
        `, document.body.appendChild(e), e)).style.display = "flex", document.body.style.overflow = "hidden"
        }, hide: function () {
            t && (t.style.display = "none", document.body.style.overflow = "")
        }
    }
}()

function generateTimestampedUUID() {
    return (new Date).getTime() + "_" + "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (e) {
        var t = 16 * Math.random() | 0;
        return ("x" === e ? t : 3 & t | 8).toString(16)
    })
}

function getCookie(e) {
    e = ("; " + document.cookie).split(`; ${e}=`);
    return 2 === e.length ? e.pop().split(";").shift() : ""
}

function toggleLoadingAnimation(e) {
    e ? LoadingAnimation.show() : setTimeout(function () {
        LoadingAnimation.hide()
    }, 5e3)
}

function getStoredFacebookAdsIds() {
    const n = JSON.parse(localStorage.getItem("myTrack")) || {};
    return ["ad_id", "campaign_id", "adset_id"].reduce((e, t) => (e[t] = n[t] || "", e), {})
}

function getOrCreateUserId() {
    var e = "CustomerId";
    let t = localStorage.getItem(e);
    return t || (t = generateTimestampedUUID().split("_")[1], localStorage.setItem(e, t)), t
}

function setShopifyVariables() {
    return new Promise(e => {
        const t = () => {
            window.shopifyVariables = {
                shopId: window.Shopify.shop,
                clientId: getCookie("_shopify_y"),
                currency: window.Shopify.currency,
                country: window.Shopify.country
            }, e()
        };
        if (void 0 !== window.Shopify && window.Shopify.shop) t(); else {
            const n = new MutationObserver(() => {
                void 0 !== window.Shopify && window.Shopify.shop && (t(), n.disconnect())
            });
            n.observe(document, {childList: !0, subtree: !0})
        }
    })
}

async function my_product_checkout(e) {
    // console.log('Product checkout initiated:', productData)
    e && e.preventDefault();
    toggleLoadingAnimation(!0);

    try {
        // Get product information from the form
        const form = document.querySelector('form[data-type="add-to-cart-form"]');
        if (!form) {
            throw new Error('Product form not found');
        }

        // Get variant ID and quantity from the form
        const variantId = form.querySelector('input[name="id"]').value;
        const quantityInput = form.querySelector('input[name="quantity"]');
        const quantity = quantityInput ? parseInt(quantityInput.value) || 1 : 1;

        if (!variantId) {
            throw new Error('Product variant ID not found');
        }

        // console.log('Adding to cart:', { variantId, quantity });

        // Add product to cart
        const addResponse = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({
                id: variantId,
                quantity: quantity
            })
        });

        if (!addResponse.ok) {
            const errorData = await addResponse.json();
            throw new Error(errorData.description || 'Failed to add product to cart');
        }

        const addResult = await addResponse.json();
        // console.log('Product added to cart:', addResult);

        // Call my_checkout function to proceed with checkout
        await my_checkout();

        return addResult;

    } catch (error) {
        console.error('Error in product checkout process:', error);
        toggleLoadingAnimation(!1);
        throw error;
    }
}

async function my_checkout(e) {
    // console.log('Checkout initiated:', e)
    e && e.preventDefault();
    toggleLoadingAnimation(!0);

    try {
        // Set Shopify variables first
        await setShopifyVariables();
        // console.log('Shopify variables:', window.shopifyVariables);

        // Fetch cart data
        const cartResponse = await fetch('/cart.json', {
            method: 'GET',
            headers: {'Content-Type': 'application/json'}
        });

        if (!cartResponse.ok) {
            throw new Error('网络响应不正常');
        }

        const cartData = await cartResponse.json();
        // console.log('Cart data:', JSON.stringify(cartData, null, 2));

        // Merge Shopify variables and cart data
        const mergedData = {
            shopInfo: window.shopifyVariables,
            cartInfo: cartData,
            userId: getOrCreateUserId(),
            facebookInfo: getStoredFacebookAdsIds(),
            timestamp: new Date().toISOString()
        };

        // console.log('Merged data for API:', JSON.stringify(mergedData, null, 2));

        // POST merged data to API endpoint
        const apiResponse = await fetch(`${apiDomain}/api/shopify/checkout`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(mergedData)
        });

        if (!apiResponse.ok) {
            throw new Error('API请求失败');
        }

        const apiResult = await apiResponse.json();
        console.log('API response:', apiResult);
        if (apiResult.token) {
            window.location.href = `${checkoutUrl}${apiResult.token}`;
        } else {
            window.location.href = `/cart`;
        }
        // Handle successful API response here
        // For example, redirect to checkout or show success message
        return apiResult;

    } catch (error) {
        console.error('Error in checkout process:', error);
        // Handle error appropriately
        throw error; // Re-throw if you want calling code to handle it
    } finally {
        toggleLoadingAnimation(!1);
    }
}
